import { render, staticRenderFns } from "./ManageAssignment.vue?vue&type=template&id=780da435"
import script from "../../services/assignment/manage-assignment.js?vue&type=script&lang=js&external"
export * from "../../services/assignment/manage-assignment.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports